import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilValue } from 'recoil';
import { useHippoText } from '../../../../hooks/useHippoText';
import { Link, NumberField } from '@flos/react-ui';
import ViewInformationModal from '../../../../shared_components/ViewInformationModal/ViewInformationModal';
import { useState } from 'react';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { track } from '../../../../utils/trackingUtil';
import { FLAVOUR_NAME } from '../../../../constants/coverable';
import type {
    CaravanOnsaDTO,
    TrailerOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/uvp';
import { currentOnsaCoverableSelector } from '../../../../recoil/selectors/currentOnsaCoverableSelector';

const AgeOfOldestPersonInHouseholdOfUvpStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const coverable = useRecoilValue<CaravanOnsaDTO | TrailerOnsaDTO>(currentOnsaCoverableSelector);
    const { flavourName } = coverable;
    const isCaravan = flavourName === FLAVOUR_NAME.UVP_CARAVAN;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [age, setAge] = useState(coverable?.ageOfOldestInHousehold);

    const onNext = (): void => {
        setIsLoading(true);

        updateCoverableInformation({
            ...coverable,
            ageOfOldestInHousehold: age
        });
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            [isCaravan ? 'caravan' : 'trailer']: {
                publicId: coverable?.publicId ?? '',
                fixedId: coverable?.fixedId ?? '',
                ageOfOldestInHousehold: age
            },
            productToUpdate: flavourName
        };
        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${flavourName}CoverableInformationAgeOfOldestInHousehold`, [
                {
                    ageOfOldestInHousehold: age
                }
            ]);
            setIsLoading(false);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            onPrevious={goPrevious}
            disableNext={isLoading || !age}
            isNextLoading={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText(
                    'DSS-COVERABLE-INFORMATION-STEP-AGE-OF-OLDEST-IN-HOUSEHOLD-HEADER'
                )}
            >
                <NumberField
                    label={getHippoText(
                        'DSS-COVERABLE-INFORMATION-STEP-AGE-OF-OLDEST-IN-HOUSEHOLD--INPUT'
                    )}
                    value={age?.toString()}
                    onChange={(event) => {
                        setAge(parseInt(event.target.value));
                    }}
                    onBlur={(event): void => {
                        updateCoverableInformation({
                            ageOfOldestInHousehold: parseInt(event.target.value)
                        });
                    }}
                    minLength={1}
                    maxLength={3}
                    disabled={isLoading}
                />
                <div className="u-text-right">
                    <Link
                        className="u-spacing-stack-top-6"
                        onClick={() => {
                            setShowModal(true);
                        }}
                        theme="logo"
                    >
                        {getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-AGE-OF-OLDEST-IN-HOUSEHOLD-WHY-DO-YOU-ASK-THAT'
                        )}
                    </Link>
                </div>
            </CoverableDetailsTemplate>
            {showModal && (
                <ViewInformationModal
                    closeModal={() => {
                        setShowModal(false);
                    }}
                    showModal={showModal}
                    modalProps={{
                        title: getHippoText('DSS-INFO-MODAL-UVPLOB-AGE-TITLE'),
                        description: getHippoText('DSS-INFO-MODAL-UVPLOB-AGE-BODY')
                    }}
                />
            )}
        </WizardPagetemplate>
    );
};

export default AgeOfOldestPersonInHouseholdOfUvpStep;
